// @flow
/* eslint react/jsx-no-bind:0 */
/* global Node */

import React, { Component } from 'react';
import i18n from 'app/common/lib/i18n';
// eslint-disable-next-line pinterest/no-deprecated-imports
import LegacyButton from 'app/common/react/ui/deprecated/LegacyButton';
// eslint-disable-next-line pinterest/no-deprecated-imports
import LegacyModal from 'app/common/react/ui/deprecated/LegacyModal';

type DeleteDidItFormProps = {
  // confirmed if non-null id
  onDeleteConfirmation: (confirmedDidItId: ?string) => void,
  didItData: ?{ id: string },
};
const clickdownEvents = ['mousedown', 'touchstart'];
export default class DeleteDidItModal extends Component<DeleteDidItFormProps, void> {
  // HACK: workaround document listener for clicks on flyout-controller.
  //       Flyout-controller has similar event listeners on document that
  //       make the flyout disappear, by attaching listeners to body and
  //       stopping the event bubbling
  componentDidMount() {
    clickdownEvents.forEach((evt: string) => {
      if (document.body) {
        document.body.addEventListener(evt, this.handleClick);
      }
    });
  }

  componentWillUnmount() {
    clickdownEvents.forEach((evt: string) => {
      if (document.body) {
        document.body.removeEventListener(evt, this.handleClick);
      }
    });
  }

  handleClick = (e: any) => {
    const target: Node = e.target;

    // prevent flyout dismiss
    e.stopPropagation();
    e.preventDefault();
    if (!(this.node && this.node.contains(target))) {
      // don't close the flyout either, just the modal
      this.props.onDeleteConfirmation(null);
    }
  };

  node: ?Node;

  render() {
    const { onDeleteConfirmation, didItData } = this.props;
    const didItId = didItData && didItData.id;

    return (
      <LegacyModal onHide={onDeleteConfirmation.bind(null, null)}>
        <div className="ConfirmDialog Module inModal" style={{ outline: 'none' }}>
          <form
            className="standardForm"
            ref={(r) => {
              this.node = r;
            }}
          >
            <h1>{i18n._('Are you sure?', 'Confirmation dialog for deleting data')}</h1>
            <div className="body">
              <p>
                {i18n._('This will remove this photo', 'Confirmation dialog for deleting data')}
              </p>
            </div>
            <div className="formFooter">
              <div className="formFooterButtons">
                <LegacyButton
                  onClick={onDeleteConfirmation.bind(null, null)}
                  text={i18n._('Cancel', 'Cancel the deleting data in a modal form')}
                />
                <LegacyButton
                  className="confirm"
                  onClick={onDeleteConfirmation.bind(null, didItId)}
                  text={i18n._('Delete', 'Confirmation of deleting data')}
                  type="primary"
                />
              </div>
            </div>
          </form>
        </div>
      </LegacyModal>
    );
  }
}
